import { InjectionToken } from '@angular/core';
import { FirebaseOptions } from 'firebase/app';

export const FIREBASE_OPTIONS = new InjectionToken<FirebaseOptions>('FIREBASE_OPTIONS');